export type Subsection = (typeof SUBSECTIONS_KEYS)[number];

export const SUBSECTIONS_KEYS = [
  'risk-signals',
  'rules',
  'user-data',
  'business-data',
  'business-details',
  'people',
  'registrations',
  'watchlist',
  'offices',
  'documents',
  'more-information',
  'field-validations',
  'duplicate-data',
  'device-insights',
  'other-insights',
] as const;

export const BUSINESS_INSIGHT_SUBSECTIONS = [
  'business-details',
  'people',
  'registrations',
  'watchlist',
  'offices',
] as const;

export type BusinessInsightSubsection = (typeof BUSINESS_INSIGHT_SUBSECTIONS)[number];
